<template>
  <div class="driver-remit-payment">
    <div class="background" @click="close" />

    <div ref="scrollable" class="wrapper no-scrollbar">
      <div class="close-wrapper" @click="close">
        <button class="delete is-large" />
      </div>

      <!-- <div v-if="!isShowingDetail" class="subtitle"> -->
      <!-- <div class="subtitle">{{ $t("payment.transfer-payment") }}</div> -->
      <div class="subtitle">
        {{ $t("payment.transfer-payment") }}
        <b class="has-text-black">{{ t.data.for_date }}</b>
      </div>

      <div class="amount">
        <span class="to-pay" @click="toPayInfo">
          {{ $t("payment.to-remit") }}: <b>{{ currency }}{{ amount }}</b>
          <span v-if="t.data.payment_receipt_pic" class="button is-light is-rounded is-small has-text-success"
            style="margin-left: 6px; padding: 6px">
            <i class="far fa-check-circle fa-lg" />&nbsp;
            <span class="is-uppercase">{{ $t("paid") }}</span>
          </span>
        </span>
      </div>

      <div v-if="isShowingDetail" class="double-check">
        <i>* {{ $t("payment.remember-to-upload-payment-slip") }} *</i>
        <br />
        <i>* {{ $t("payment.double-check-bank-account-name") }} *</i>
        <!-- <br />
        <i>* {{ $t("payment.put-tuk-mobile-number-in-note") }} *</i> -->
      </div>

      <!-- <div v-if="showHint" class="has-text-grey" style="margin-bottom: 10px">
        <p>You can pay using the following contactless payment options:</p>
      </div> -->

      <div v-if="promptPay && !showBankTransfer">
        <div class="payment-type" @click="togglePromptPay">
          <span>PromptPay</span>
          <span class="is-pulled-right">
            <!-- <span v-if="showPromptPay" class="fa fa-chevron-up" /> -->
            <span v-if="showPromptPay" class="has-text-grey">Hide <i class="fa fa-chevron-up" /></span>
            <span v-else class="show-details has-text-link">{{ $t("show-details") }}&nbsp;<i
                class="fa fa-chevron-down" /></span>
          </span>
        </div>
        <div v-if="showPromptPay">
          <img :src="promptPay" />
          <!-- <p class="double-check has-text-link">
            <i>* Double check account name before transferring *</i>
            <br />
            <i>* Remember to upload payment slip below *</i>
          </p> -->
        </div>
      </div>

      <!-- <div v-if="bankAccount && !showPromptPay">
        <div class="payment-type" @click="toggleBankTransfer">
          {{ $t("payment.bank-transfer") }}
          <span class="is-pulled-right">
            <span v-if="showBankTransfer" class="fa fa-chevron-up" />
            <span v-else class="show-details has-text-link">{{ $t("show-details") }}&nbsp;<i
                class="fa fa-chevron-down" /></span>
          </span>
        </div> -->

      <!-- <div v-if="showBankTransfer"> -->
      <div class="bank-account-wrapper">
        <!-- <p style="font-size: 1.15em; color: grey; margin-bottom: 8px">
              {{ $t("payment.bank-account-details") }}
            </p>
            -->
        <p class="key">{{ $t("payment.bank-name") }}</p>
        <p>{{ bankAccount.bank_name }}</p>
        <p class="key">{{ $t("payment.account-number") }}</p>
        <p @click="copyBankAccountNumber">
          {{ bankAccount.account_number }}
          <i class="fa fa-copy is-pulled-right has-text-grey" />
        </p>
        <p class="key">{{ $t("payment.name-on-account") }}</p>
        <p>{{ bankAccount.name_on_account }}</p>
        <p class="key">{{ $t("payment.transaction-note") }}</p>
        <p @click="copyTransactionNote">
          TUK {{ userThaiPhoneNumber }}
          <i class="fa fa-copy is-pulled-right has-text-grey" />
        </p>
        <!-- <p class="hint">
              Please put your TUK mobile number so we can track it
            </p> -->
      </div>
      <!-- </div> -->
      <div style="height: 70px" />
    </div>


    <div class="submit-wrapper">
      <div v-if="t.state === 'pending' && !showBankTransfer" class="button is-fullwidth is-medium is-success"
        @click="toPayInfo">
        <i class="fa fa-check" />&nbsp;
        {{ $t("payment.payment-receipt-uploaded") }}
      </div>
      <div v-else class="button is-fullwidth is-medium is-info" @click="clickUpload">
        <i class="fa fa-camera-retro fa-lg" />&nbsp;
        {{ $t("payment.upload-payment-receipt") }}
      </div>
    </div>

    <!-- accept="image/*" -->
    <input type="file" ref="file" style="display: none" accept="image/png,image/jpeg,image/jpg,image/bmp"
      @change="uploadReceipt($event)" />
  </div>
</template>

<script>
import imageCompression from "browser-image-compression";
// const shortid = require("shortid");

export default {
  name: "DriverRemitPayment",
  components: {},
  props: {
    // bankAccount: Object,
    // promptPay: String,
    // amount: Number,
    t: Object,
  },
  data() {
    return {
      showHint: true,
      showPromptPay: false,
      showBankTransfer: true,
      bankAccount: {
        bank_name: "Siam Commercial Bank (SCB) / ธนาคารไทยพาณิชย์ ",
        account_number: "438-106446-2",
        name_on_account: "ALLOPATRA CO,LTD / บจ อัลโลพัตรา",
      },
      promptPay: null, // if we get a company bank account with promptpay...
      currency: this.currencySymbol("th"),
    };
  },
  computed: {
    isShowingDetail() {
      return this.showPromptPay || this.showBankTransfer;
    },
    amount() {
      return this.t.data.remit_amount;
    },
    userThaiPhoneNumber() {
      var phone = this.$store.state.user.phone_number;
      if (phone.startsWith("+66")) {
        return phone.replace("+66", "0");
      }
      return phone;
    },
  },
  mounted() {
    if (this.t.state === "pending") this.showBankTransfer = false;
  },
  methods: {
    close() {
      this.$emit("close");
    },
    toPayInfo() {
      if (this.t.data.payment_receipt_pic) {
        this.paymentReceiptConfirmation();
      } else {
        var msg = "Remember to upload payment slip";
        this.infoToast(msg, "top");
      }
    },
    copyBankAccountNumber() {
      var accountNumber = this.bankAccount.account_number;
      this.$copyText(accountNumber);
      var msg = `Copied Account Number to clipboard<br>${accountNumber}`;
      this.infoToast(msg, "top");
    },
    copyTransactionNote() {
      var note = `TUK ${this.userThaiPhoneNumber}`;
      this.$copyText(note);
      var msg = `Copied Transaction Note to clipboard<br>${note}`;
      this.infoToast(msg, "top");
    },
    paymentReceiptConfirmation() {
      var pic = this.t.data.payment_receipt_pic;
      var msg = `Payment Receipt Has Been Uploaded
      <p style='margin-top:16px'><img src='${pic}' style='border-radius:8px' /></p>`;
      this.successToast(msg, "bottom", 12000);
    },
    tippingFAQ() {
      this.$swal({
        html: `<div style='text-align:left'>
            <p style='font-size:1.2em; margin-bottom:12px'>
<i class='fa fa-motorcycle'></i>&nbsp;Tipping the Driver</p>
            <p style='margin-bottom:10px'>
This is the most common question we get asked. Thank you for supporting local drivers. 
            </p>
            <p style='margin-bottom:10px'>
Tipping is entirely optional. If you'd like to tip the driver you can do so in cash when they drop off your order or via the contactless payment options provided. 
            </p>
            <p style='margin-bottom:10px'>
These payments go directly to the driver, so any amount over the bill is a driver tip.
            </p>
            </div>`,
        showCloseButton: true,
        showConfirmButton: false,
      });
    },
    toggleBankTransfer() {
      this.showHint = false;
      this.showBankTransfer = !this.showBankTransfer;
      if (this.showPromptPay) this.showPromptPay = false;
    },
    togglePromptPay() {
      this.showHint = false;
      this.showPromptPay = !this.showPromptPay;
      if (this.showBankTransfer) this.showBankTransfer = false;
    },
    clickUpload() {
      this.$refs.file.click();
      var loader = this.loadingDots("lightblue");
      setTimeout(() => loader.hide(), 5000);
    },
    // should send notification to driver about payment receipt upload
    attachReceiptToOrder(picURL) {
      var loader = this.loadingDots("lightgreen");
      this.$store
        .dispatch("patchTransaction", {
          transactionID: this.t.id,
          data: {
            state: "pending",
            data: { payment_receipt_pic: picURL },
          },
        })
        .then(() => {
          this.successToast("Payment Receipt Uploaded");
          this.log("upload_remit_payment_receipt", this.t.id);
          this.$emit("update");
          this.close();
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    uploadReceipt(e) {
      if (!e.target.files) return;
      if (e.target.files.length === 0) return;
      var originalFile = e.target.files[0];

      var loader = this.loadingDots();
      var options = {
        maxSizeMB: 0.3,
        maxWidthOrHeight: 700,
        useWebWorker: true,
      };
      imageCompression(originalFile, options)
        .then((compressedFile) => {
          var sizeKB = Math.round(compressedFile.size / 1024);
          this.console(`compressedFile size ${sizeKB} KB`); // smaller than maxSizeMB

          imageCompression
            .getDataUrlFromFile(compressedFile)
            .then((base64) => {
              var data = {
                name: this.$shortid.generate() + ".png", //`payment_${this.orderID}.png`,
                content: base64.replace(/^data:image\/[a-z]+;base64,/, ""),
                businessID: "driver_remit", //this.t.business_id,
                imageType: "remit_payment_receipt",
              };
              this.$store
                .dispatch("uploadImageAWS", data)
                .then((res) => {
                  console.log("uploadImageAWS", res.data);
                  var picURL = res.data.compressed_image_url; //JSON.parse(res.data.body).Location;
                  this.attachReceiptToOrder(picURL);
                })
                .catch((err) => this.apiError(err))
                .finally(() => loader.hide());
            })
            .catch((err) => this.console("imageData error", err));
        })
        .catch((err) => this.console("imageCompression error", err));
    },
  },
};
</script>

<style scoped>
.driver-remit-payment {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  /* background-color: rgba(255, 255, 255, 0); */
  background-color: rgba(128, 128, 128, 0.5);
  z-index: 21;
  backdrop-filter: blur(1px);
}

.background {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;
}

.wrapper {
  position: absolute;
  bottom: 0;
  right: 0;
  max-width: 500px;
  height: auto;
  max-height: calc(100vh - 60px);
  overflow: scroll;
  width: 100vw;
  overflow-x: hidden;
  padding: 12px;
  background-color: rgba(255, 255, 255, 1);
  text-align: left;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  transition: max-height 0.2s linear;
  box-shadow: 0 0 3px #444;
}

.subtitle {
  font-size: 1.25em;
  font-weight: 500;
  margin-bottom: 16px;
}

.close-wrapper {
  /* position: absolute; */
  position: fixed;
  /* top: 0; */
  margin-top: -12px;
  right: 0;
  padding: 8px 12px;
  z-index: 2;
}

.submit-wrapper {
  position: fixed;
  bottom: 0;
  /* left: 0; */
  width: 100vw;
  right: 0;
  max-width: 500px;
  padding: 12px;
  background-color: whitesmoke;
  /* background-color: rgba(232, 232, 232, 0.5);
  backdrop-filter: blur(1px); */
}

img {
  border-radius: 2px;
  width: 100%;
  /* border: 6px solid gold; */
}

.payment-type {
  font-size: 1.1em;
  /* white-space: pre-wrap; */
  font-weight: 450;
  /* opacity: 0.8; */
  margin-bottom: 8px;
  margin-top: 16px;
  background-color: white;
  border: 1px solid lightgrey;
  padding: 3px 12px;
  border-radius: 20px;
}

.show-details {
  color: grey;
  font-weight: 450;
  font-size: 0.9em;
}

.also-cash {
  margin-top: 16px;
  font-size: 0.9em;
  color: grey;
  background-color: white;
  padding: 0 4px;
  border-radius: 2px;
}

.bank-account-wrapper {
  background-color: rgb(190, 247, 255);
  border-radius: 3px;
  padding: 6px 8px;
}

.amount {
  /* margin-top: 12px; */
  /* margin-bottom: 16px; */
  margin-bottom: 24px;
  margin-top: 20px;
  font-weight: 500;
  font-size: 1.2em;
  text-align: center;
}

.to-pay {
  background-color: white;
  border-radius: 3px;
  padding: 4px 6px;
  border: 1px solid lightgrey;
}

.label,
.key {
  display: inline-block;
  color: #888;
  font-size: 0.8em;
  font-weight: 500;
  width: 130px;
}

.double-check {
  color: var(--link);
  padding: 0 4px;
  font-size: 0.9em;
  background-color: white;
  border-radius: 2px;
  margin-bottom: 14px;
  /* margin-top: 34px; */
}
</style>